import React from 'react';
import ContentLoader from 'react-content-loader';

import { getLoaderColors } from '../../utils/theme';

import { ThemeContext } from '../../context/ThemeContext';

const Placeholder = props => {
    return (
        <ThemeContext.Consumer>
            {
                ({ theme }) => (
                    <div className="card placeholder">
                        <div className="card-inner">
                            <div className="card-main">
                                <div className="card-body">
                                    <ContentLoader width="250" height="18" animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                                        <rect x="0" y="5" rx="4" ry="4" width="250" height="8" />
                                    </ContentLoader>
                                </div>

                                <div className="card-foot">
                                    <ContentLoader width="184" height="18" animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                                        <rect x="0" y="5" rx="4" ry="4" width="8" height="8" />
                                        <rect x="14" y="5" rx="4" ry="4" width="80" height="8" />
                                        <rect x="104" y="5" rx="4" ry="4" width="80" height="8" />
                                    </ContentLoader>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </ThemeContext.Consumer>
    )
}

export default Placeholder;
